import ButtomTab from "./ButtomTab";
import { useState, useMemo, useEffect, useRef } from "react";
import { Outlet, Link, router, useParams, useNavigate } from "react-router-dom";
import Chat from "../../compoenents/Chat";
import Cookies from "js-cookie";
import LoginCheck from "../../LoginCheck/page";
import { AppValues, API, ApiUrl } from "../../Values";
import { useAudio } from "../../../AudioContext";

export default function CustomerAlert() {
  const [Data, SetData] = useState([]);

  const { audio, audioAllowed } = useAudio();

  //---------CHECK LOGIN------------------------------
  LoginCheck();
  var userinfo = [];
  var Username = "";
  var UserID = "";
  if (Cookies.get("userinfo")) {
    userinfo = JSON.parse(Cookies.get("userinfo"));
    Username = userinfo[0].Name;
    UserID = userinfo[0].ID;
  }
  //--------------------------------------------

  //--------------------------------------------
  const params = useParams();

  useEffect(() => {
    GetData();
  }, []);

  const [intervalActive, setIntervalActive] = useState(true);
  const fetchIntervalRef = useRef(null);
  // جلب الرسائل بشكل دوري
  useEffect(() => {
    if (intervalActive) {
      fetchIntervalRef.current = setInterval(() => {
        GetData();
      }, 5000);
    }
    return () => clearInterval(fetchIntervalRef.current);
  }, [intervalActive]);

  async function GetData() {
    try {
      const post = {
        Name: Username,
        ID: UserID,
        statue: "",
        Action: "Alerts",
      };
      const respons = await fetch(`${ApiUrl}/Customer/CalculateData.php`, {
        method: "POST",
        body: JSON.stringify(post),
      });
      const data_ = await respons.json();
      console.log(data_);
      const datanew = JSON.stringify(data_);
      const dataold = JSON.stringify(Data);
      // if (datanew.length != dataold.length) {
      // if (Orders.length !== data.length) {
      if (datanew !== dataold) {
        if (audioAllowed) {
          audio.play(); // تشغيل الصوت عند الإشعارات الجديدة
        }
        SetData(data_);
      }
    } catch (error) {
      return error;
    }
  }

  return (
    <>
      <div className="row m-auto" style={{ maxWidth: "500px" }}>
        <div className="col-12 p-1 bg-orange">
          <h4>التنبيهات</h4>
        </div>
        <div className="col-master col-card-alert col-12 my-4 pt-2">
          {Data.length > 0 ? <CardAlerts /> : null}
          {Data.length < 1 ? <NoAlerts /> : null}
          <br /><br /> <br /><br />
        </div>
      </div>
      <ButtomTab />
      <Chat />
    </>
  );

  //------------------------------------
  function CardAlerts() {
    return Data.map((x, index) => {
      return (
        <>
          <div
            key={index}
            className="card-content card"
            style={{ maxWidth: "500px" }}
          >
            <div className="card-body p-0">
              <div className="row">
                <div className="col-2 text-center">
                  <i
                    className="fa fa-user-tie"
                    style={{ fontSize: "30px", borderRadius: "30px" }}
                  ></i>
                </div>
                <div className="col-10">
                  <small style={{ color: "#000" }}>{x.msg} </small>
                  {x.msg != x.Description && (
                    <>
                      <br />
                      <small style={{ color: "#000" }}>{x.Description} </small>
                    </>
                  )}

                  <br />
                  <small> {x.date + " - " + x.time}</small>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    });
  }
}

function NoAlerts() {
  return (
    <div className="card m-0">
      <div className="card-body text-center " style={{ height: "650px" }}>
        <br /> <br /> <br />
        <br /> <br /> <br />
        <i
          style={{ fontSize: "100px" }}
          className="fa-solid fa-bell-slash m-4 p-4 text-secondary"
        ></i>
        <h4>لا يوجد اى تنبيهات </h4>
        <br /> <br /> <br />
      </div>
    </div>
  );
}
